import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditNoteTwoToneIcon from '@mui/icons-material/EditNoteTwoTone';

interface OrderFoodActionsProps {
    onEditClick: () => void;
    onRemoveClick: () => void;
}

const OrderFoodActions: React.FC<OrderFoodActionsProps> = ({ onEditClick, onRemoveClick }) => {
    return (
        <Box display={"flex"} flexDirection={"row"} alignItems={"flex-start"}>
            <IconButton aria-label="edit-order-food" onClick={onEditClick}>
                <EditNoteTwoToneIcon fontSize="inherit" />
            </IconButton>
            <IconButton aria-label="delete-order-food" onClick={onRemoveClick}>
                <DeleteTwoToneIcon fontSize="inherit" color='inherit' />
            </IconButton>
        </Box>

    )
}

export default OrderFoodActions;